import { ApiService } from "./ApiService";
import { PaymentType } from "../types/PaymentType";

const baseUrl = "/services/rateagreement/api/payment";

class PaymentService extends ApiService {
    /**
     * Get all allowed payment types from backend
     * @param debtNumber - the debt number of a given user
     * @param amount - the rate amount to pay
     * @return List of allowed payment types
     */
    async getAllowedPaymentTypes(debtNumber: string, amount?: number): Promise<PaymentType[]> {
        const response = await fetch(baseUrl + "/" + debtNumber + "/payment-methods?amount=" + amount, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const debtorResponse = await this.handleResponse(response);
        return debtorResponse.json();
    }
}

export default new PaymentService();
